'use client'

import Image from 'next/image'
import favicon from '@/public/assets/favicon/favicon.png'

/**
 * A component that shows a loading logo while the user is being redirected to a new page.
 */
export const LoadingLogo = () => {
  return (
    <div className='flex justify-center items-center h-screen'>
      {/* The loading spinner */}
      <div className='absolute animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-primary'></div>
      {/* The mini logo */}
      <Image
        src={favicon}
        alt='PhysicianGPS Logo'
        width={64}
        height={64}
        style={{ width: 'auto' }}
      />
    </div>
  )
}
